import { supabase } from '@/integrations/supabase/client';

const SESSION_KEY = 'er_track_session';
const DEDUP_PREFIX = 'er_lee_';
const DEDUP_WINDOW_MS = 30 * 60 * 1000;

function getSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch { return 'no_session'; }
}

function recently(key: string): boolean {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return false;
    const ts = parseInt(raw, 10);
    return !Number.isNaN(ts) && Date.now() - ts < DEDUP_WINDOW_MS;
  } catch { return false; }
}

function mark(key: string) {
  try { sessionStorage.setItem(key, String(Date.now())); } catch { /* noop */ }
}

interface TrackArgs {
  event_type: string;
  entity_type?: string | null;
  entity_id?: string | null;
  metadata?: Record<string, any>;
  /** Dedup within session for this scope; if omitted, every call fires. */
  dedupKey?: string;
}

export async function trackLandingEvent({ event_type, entity_type, entity_id, metadata, dedupKey }: TrackArgs) {
  if (dedupKey) {
    const k = `${DEDUP_PREFIX}${dedupKey}`;
    if (recently(k)) return;
    mark(k);
  }
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from('landing_engagement_events' as any).insert({
      event_type,
      entity_type: entity_type ?? null,
      entity_id: entity_id ?? null,
      session_id: getSessionId(),
      user_id: user?.id ?? null,
      metadata: metadata ?? {},
    } as any);
  } catch (err) {
    console.warn('[landing analytics] insert failed', err);
  }
}
